import http from "@/http-common";

/* eslint-disable */
class LoginAdminMaintenanceDataService {
    getLoginAdminList(): Promise<any> {
        return http.api.post("/getLoginAdminList/");
    }
    checkLoginAdmin(data: any): Promise<any> {
        return http.api.post("/checkLoginAdmin/", data);
    }
    insertLoginAdmin(data: any): Promise<any> {
        return http.api.post("/insertLoginAdmin/", data);
    }
}

export default new LoginAdminMaintenanceDataService();